<div class="global-search" [class.global-search--open-mobile]="isOpen" (click)="$event.stopPropagation()">
  <div class="global-search-input-wrap">
    <i class="bi bi-search global-search-icon" aria-hidden="true"></i>
    <input
      type="text"
      class="form-control global-search-input"
      [value]="query"
      [placeholder]="'Search.placeholder' | translate"
      [attr.aria-label]="'Search.placeholder' | translate"
      (focus)="open()"
      (input)="onInput($any($event.target).value)"
      (keydown.arrowdown)="onArrowDown($any($event))"
      (keydown.arrowup)="onArrowUp($any($event))"
      (keydown.enter)="onEnter()"
    />
    <button
      type="button"
      class="btn btn-link global-search-clear"
      *ngIf="query"
      (click)="clear()"
      [attr.aria-label]="'Search.clear' | translate"
    >
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
    <div class="global-search-spinner" *ngIf="loading">
      <div class="spinner-border spinner-border-sm" role="status">
        <span class="visually-hidden">{{ 'General.loading' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="global-search-dropdown" *ngIf="isOpen">
    <div class="global-search-summary" *ngIf="query.trim().length >= 2">
      <span>{{ 'Search.totalHits' | translate:{ count: totalHits } }}</span>
      <button type="button" class="btn btn-link btn-sm d-lg-none p-0 ms-2" (click)="onEscape()" [attr.aria-label]="'General.close' | translate">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>

    <ng-container *ngIf="groups.length > 0; else noResults">
      <div class="global-search-group" *ngFor="let group of groups; let groupIndex = index; trackBy: trackByGroup">
        <div class="global-search-group-title">
          <i class="bi" [ngClass]="group.icon" aria-hidden="true"></i>
          <span>{{ translate(group.moduleLabel) }}</span>
          <span class="badge badge-soft-secondary ms-auto">{{ group.total }}</span>
        </div>

        <button
          type="button"
          class="global-search-item"
          *ngFor="let item of group.items; let itemIndex = index; trackBy: trackByItem"
          [class.global-search-item--active]="isItemActive(groupIndex, itemIndex)"
          [attr.data-search-index]="getFlatIndex(groupIndex, itemIndex)"
          (mouseenter)="onItemHover(groupIndex, itemIndex)"
          (click)="navigateTo(item)"
        >
          <span class="global-search-item-title">{{ item.title }}</span>
          <span class="global-search-item-subtitle" *ngIf="item.subTitle">{{ item.subTitle }}</span>
          <span class="badge ms-auto" [ngClass]="item.badgeClass" *ngIf="item.badge">{{ item.badge }}</span>
        </button>
      </div>
    </ng-container>

    <ng-template #noResults>
      <div class="global-search-empty" *ngIf="query.trim().length >= 2 && !loading">
        {{ 'Search.noResults' | translate }}
      </div>
    </ng-template>
  </div>
</div>
